import store from '@/store';
import axios from 'axios'
import { Message } from 'element-ui';
import { getCookie, setCookie, clearCookies } from "@/utils/cookie";
import { domainName } from '@/utils/domainName'

// axios.defaults.timeout = 30000;
// axios.defaults.baseURL = 'https://betawww.yuankong-ai.com/api';

// 定义一个变量，用于标记 token 刷新的状态
let isRefreshing = false;
let refreshSubscribers = [];
// request拦截
axios.interceptors.request.use(
    config => {
        let access_token = store.state.access_token;
        const isToken = (config.headers || {}).isToken
        if (JSON.parse(getCookie('queryParams')) && Object.keys(JSON.parse(getCookie('queryParams'))).length != 0) {
            // console.log(Object.entries(JSON.parse(getCookie('queryParams'))))
            let arrs = Object.entries(JSON.parse(getCookie('queryParams')))
            for (let [key, value] of arrs) {
                config.data[key] = value;
            }
        }
        config.data['language'] = getCookie('language') ? getCookie('language') : 'zh_CN';
        config.data['access_token'] = getCookie('access_token') ? getCookie('access_token') : '';
        config.data['client_type'] = 'web';
        // 不需要token
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//  response拦截
axios.interceptors.response.use(
    async(res) => {
        if (res.status !== 200 || res.data.code === 1) {
            const text = res.data.msg
            Message({ message: text, type: 'error' });
            return Promise.reject(res);
        } else if (res.data.code === 20001) {
            return Promise.resolve(res);
        } else if (res.data.code === 10020) {
            return Promise.resolve(res);
        } else if (res.data.code === 0) {
            return Promise.resolve(res);
        } else if (res.data.code === 10005 || res.data.code == 10001) {
            // 业务意图：身份选择属于当前站登录流程，凭证失效时需留在当前页面重新登录，不能直接跳到工作台。
            // 只有身份选择显式标记的校验会跳过默认跳转，其它请求保持原有失效处理。
            if (res.config && res.config.skipLoginRedirect) {
                return Promise.resolve(res);
            }
            clearCookies()
            window.location.href = domainName.api1
            return Promise.resolve(res);

        } else if (res.status !== 200 || res.data.code != 0) { //兜底
            const text = res.data.msg
            Message({ message: text, type: 'error' });
            return Promise.reject(res);
        }
        return res
    },
    error => {
        if (process.env.NODE_ENV == 'development') {
            console.error('请求失败:', error);
        }
        if (error.message == 'Network Error') {
            // 处理网络错误（比如记录日志、上报、触发重试等）
            console.log('检测到网络错误，已静默处理');
        }
        if (error.code == "ERR_BAD_RESPONSE") {
            Message({ message: error.message, type: 'error' });
        }
        return Promise.reject(error);
    }
);

export default axios;
